import { createSelector } from 'reselect';
import { UserRole } from './types';
import { emptyObject } from '~/store/constants';
import { get } from '~/utils/object';

export const selectAuth = (state: any) => state.auth;
export const selectVerify = (state: any) =>
  get(state, 'auth.verified', emptyObject);

export const isVerified = createSelector(
  [selectVerify],
  verified => verified.status,
);

export const verifiedError = createSelector(
  [selectVerify],
  verified => verified.error,
);

export const getCurrentUser = createSelector([selectAuth], auth =>
  get(auth, ['user'], null),
);

export const getEnabledFeatureFlags = createSelector([getCurrentUser], user =>
  get(user, 'roles', [])
    .filter((role: UserRole) => role.isGlobal)
    .map((role: UserRole) => role.name),
);

export const getIntercomHash = createSelector([selectAuth], auth => auth.help);
